import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

export const useScroll = () => {
  const [hasScroll, setHasScroll] = useState(false);
  const pathname = usePathname();

  const routeIsHomePage =
    pathname === '/' ||
    pathname === '/about' ||
    pathname === '/hosting' ||
    pathname.startsWith('/campaigns');

  useEffect(() => {
    const handleScroll = () => {
      if (routeIsHomePage) {
        // On homepage: transparent until scrolled, then white background
        setHasScroll(window.scrollY > 20);
      } else {
        // On other pages: always white background
        setHasScroll(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call immediately to set initial state

    return () => window.removeEventListener('scroll', handleScroll);
  }, [routeIsHomePage]); // Add routeIsHomePage as dependency

  return hasScroll;
};
